import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import React from "react";
import { TechnicalSpecificationAttributeHeadline } from "../../product-technical-specification-page-layout/technical-section-attribute-headline";

import { Global } from "@emotion/react";
import { css } from "@emotion/react";

import { CSS_MQ } from "../../../styles/breakpoints";
import type { TranslatedValue } from "@swo/storefront";

export const SectionHeadline: ReactTFC<{
  selectedProductKeys: Array<string>;
  headline: string | TranslatedValue;
  groupKey: string;
}> = props => {
  return (
    <>
      {props.selectedProductKeys.map(selectedProductKey => {
        return (
          <div key={selectedProductKey} css={sectionHeadlineWrapperStyles}>
            <TechnicalSpecificationAttributeHeadline groupKey={props.groupKey} label={props.headline} />
          </div>
        );
      })}
    </>
  );
};

const sectionHeadlineWrapperStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 10px 0;
  ${CSS_MQ.atLeastMd} {
    padding: 10px;
  }
`;
